var isBrowser = typeof document !== 'undefined' && document.toString().indexOf('HTMLDocument') !== -1;
var _isMobile = isBrowser && typeof window !== 'undefined' && 'ontouchstart' in window;
var isPC = isBrowser && !_isMobile;
var isMobile = !isPC;
export { isBrowser, isMobile, isPC };
